import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getPlantillaContent (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getPlantillasImagen

      const clone = JSON.parse(JSON.stringify(data))

      resolve(clone)
    })
  } else {
    const req = {
      url: 'api/personalizacion/getplantillacontent',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getPlantillaContent }
